<template>
  <div class="reports-catalog">
    <!-- 📁 REPORTS CATALOGUE -->
    <v-card elevation="4" class="mb-6 catalog-header">
      <v-card-title class="pa-6">
        <v-icon size="32" color="primary" class="mr-3">mdi-folder-multiple</v-icon>
        <span class="text-h5">Catálogo de Reportes</span>
      </v-card-title>

      <!--
        P13-V5A-R5 · RETIRED. Aquí vivía el buscador ("Buscar reportes por nombre, tipo,
        autor...") y su panel de filtros por categoría, rol, formato y estado. No consultaban
        nada: filtraban en memoria el array literal `allReports` que se retira más abajo, de modo
        que las seis categorías ofrecidas (Operaciones, Finanzas, Recursos Humanos, Ventas,
        Marketing, Análisis) y los cuatro formatos (PDF, Excel, CSV, PowerPoint) describían una
        taxonomía documental que la organización no tiene. El botón "Aplicar" era
        `console.log('Filters applied')` y nada más. Se eliminan los controles en lugar de
        dejarlos inertes: un buscador sobre un catálogo inexistente promete una capacidad que el
        producto no implementa.
      -->

      <!--
        P13-V5A-R5 · RETIRED. La rejilla publicaba seis reportes corporativos con nombre, autor,
        fecha de última modificación, valoración en estrellas, número de reseñas y contador de
        descargas ("Reporte Ejecutivo Completo", 1247 descargas, 4.8 estrellas, 156 reseñas;
        "Reporte de Incidencias Críticas", 789 descargas y 4.9 estrellas; y otros cuatro por el
        estilo), más insignias Premium y niveles de complejidad. Cuatro de los seis estaban
        firmados por nombres propios que no corresponden a ningún usuario del sistema, y los dos
        restantes por "Sistema MGI". Todo ello era un literal: el archivo declaraba
        `const allReports = reactive([` bajo el rótulo `// Sample Reports Data`. Este componente
        no importaba ningún cliente HTTP —ni ApiClient, ni axios, ni fetch— y el backend no monta
        ninguna superficie de catálogo: bajo el prefijo de reportes el único montaje es
        /api/reports/organizational (backend src/app.js:568).

        Atribuir documentos a personas con nombre y apellido, y publicar cuántas veces se
        descargaron y cómo los valoraron sus lectores, es una afirmación sobre lo que esta
        organización produce y usa. El contador de descargas además se fabricaba a la vista del
        usuario: `generateReport()` hacía `report.downloads++` tras un setTimeout de 2 s, así que
        la cifra de popularidad crecía por pulsar un botón en el navegador y se perdía al
        recargar. "Vista Previa" abría un diálogo con un esqueleto de carga de 1 s y después
        mostraba únicamente el título y la descripción que ya estaban en pantalla: no había nada
        que previsualizar. Una tarjeta sin productor se retira, no se rellena.
      -->
      <v-card-text data-testid="reports-catalog-retired">
        <v-alert type="info" variant="tonal" density="compact">
          Este catálogo no tiene un productor canónico y fue retirado en P13-V5A-R5. No existe un
          repositorio de reportes corporativos en el sistema. Los reportes organizacionales con
          respaldo real se publican en el reporte organizacional (/reports/organizational).
        </v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup lang="ts">
// P13-V5A-R5 · RETIRED. Este componente no realizaba ni una sola llamada al backend: su catálogo
// completo era el literal `allReports` y todas sus acciones eran simuladas o inertes. Se eliminan
// el estado de búsqueda y paginación (`searchQuery`, `selectedCategory`, `selectedRole`,
// `selectedFormat`, `selectedStatus`, `showFilters`, `currentPage`, `itemsPerPage`), las listas de
// opciones (`categories`, `roleFilters`, `formatFilters`, `statusFilters`), el array `allReports`
// y los computados `filteredReports` y `totalPages` que lo recortaban.
//
// De los manejadores, tres eran simulaciones: `generateReport()` marcaba `generating`, emitía y
// tras 2 s incrementaba `report.downloads`; `previewReport()` encendía `loadingPreview` durante
// 1 s para simular una carga que no ocurría; y `handleReportGeneration()` sólo reenviaba la
// configuración y escribía "✅ Reporte configurado para generación" en la consola. Otros cuatro
// eran controles inertes que anunciaban capacidades inexistentes: `shareReport()`,
// `duplicateReport()` y `editReport()` eran un `console.log` con el comentario "Implement ...
// functionality", y `handleTemplateSave()` un `console.log` con el comentario "Here you would save
// the template to backend or local storage" — no había plantilla guardada en ningún sitio.
// `favoriteReport()` volteaba una marca en memoria que se perdía al recargar, de modo que
// "Favoritos" tampoco persistía nada. Se eliminan junto con `selectReport()`, `canEdit()`,
// `getComplexityColor()`, `formatDate()`, `applyFilters()`, `clearFilters()` y el watcher que
// reiniciaba la paginación.
//
// También desaparecen: el diálogo de vista previa, el montaje de `ReportConfigurationModal` (un
// formulario de 862 líneas que, al confirmar, emitía `generate` y cerraba tras un setTimeout, sin
// productor detrás), y las importaciones que quedaban sin uso — `vue`, `date-fns` con su locale
// `es`, y el store de autenticación, que sólo servía para decidir quién podía "editar" un reporte
// inventado.
//
// Se retira asimismo `defineEmits(['generate-report', 'preview-report'])`: sin acciones que
// disparar, el componente ya no puede emitir nada. EnterpriseReportsCenter.vue todavía enlaza
// `@generate-report` y `@preview-report` sobre este componente (líneas 145-148); esos enlaces son
// ahora inalcanzables y corresponden a ese archivo, no a éste.
</script>

<style scoped lang="scss">
.reports-catalog {
  .catalog-header {
    border-radius: 16px;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  }
}
</style>
